module.exports = __webpack_public_path__ + "static/frontUserNew/img/typetxt.a02a882b.svg";